import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { Consignment, ConsignmentData } from "./Consignment";

const AnalyticsConsignment = () => {
	const { t } = useTranslation();

	const data: ConsignmentData = {
		groups: [
			{
				header: t("PRIVACY_BDP_CONSIGNMENT_COMPANY_KR"),
				columns: [
					[
						t("PRIVACY_SANALYTICS_CONSIGNMENT_CLOIT_KR"),
						<Trans
							key="google-kr"
							i18nKey="PRIVACY_BDP_CONSIGNMENT_GOOGLE_KR"
							components={{
								a: (
									// eslint-disable-next-line
									<a
										href="https://cloud.google.com/terms/subprocessors"
										target="_blank"
										rel="noreferrer"
									/>
								),
							}}
						/>,
					],
					[
						t("PRIVACY_SANALYTICS_CONSIGNMENT_CLOIT_OPERATIONS_KR"),
						<Trans
							key="google-ops-kr"
							i18nKey="PRIVACY_BDP_CONSIGNMENT_GOOGLE_OPERATIONS_KR"
							components={{
								a: (
									// eslint-disable-next-line
									<a
										href="https://cloud.google.com/terms/subprocessors"
										target="_blank"
										rel="noreferrer"
									/>
								),
							}}
						/>,
					],
				],
			},
			{
				header: t("PRIVACY_BDP_CONSIGNMENT_COMPANY"),
				columns: [
					[
						t("PRIVACY_SANALYTICS_CONSIGNMENT_CLOIT"),
						<Trans
							key="google-en"
							i18nKey="PRIVACY_BDP_CONSIGNMENT_GOOGLE"
							components={{
								a: (
									// eslint-disable-next-line
									<a
										href="https://cloud.google.com/terms/subprocessors"
										target="_blank"
										rel="noreferrer"
									/>
								),
							}}
						/>,
					],
					[
						t("PRIVACY_SANALYTICS_CONSIGNMENT_CLOIT_OPERATIONS"),
						<Trans
							key="google-ops-en"
							i18nKey="PRIVACY_BDP_CONSIGNMENT_GOOGLE_OPERATIONS"
							components={{
								a: (
									// eslint-disable-next-line
									<a
										href="https://cloud.google.com/terms/subprocessors"
										target="_blank"
										rel="noreferrer"
									/>
								),
							}}
						/>,
					],
				],
			},
		],
	};

	return <Consignment data={data} testId="analytics-consignment" />;
};

export default AnalyticsConsignment;
